import React from 'react'

const OpenCloseSidebarBtn = ({ fill }) => {
  return (
    <svg
      width='14'
      height='12'
      viewBox='0 0 14 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.25 11.667L1.75 11.667L1.75 10.5003L12.25 10.5003L12.25 11.667ZM12.25 2.91699L1.75 2.91699L1.75 1.75032L12.25 1.75033L12.25 2.91699ZM7.58333 5.83366L1.75 5.83366L1.75 4.66699L7.58333 4.66699L7.58333 5.83366ZM7.58333 8.75032L1.75 8.75032L1.75 7.58366L7.58333 7.58366L7.58333 8.75032ZM12.25 6.70866L9.91667 8.75032L9.91667 4.66699L12.25 6.70866Z'
        fill={fill}
      />
    </svg>
  )
}

export default OpenCloseSidebarBtn
